import React from 'react';
import { Link } from 'react-router-dom';

class Admin_Dev extends React.Component {

  constructor(props) {
		super(props);
		//this.dummyfunction = this.dummyfunction.bind(this);
	}

	render() {
		return (
			<div>
			<h3>*** Développeurs ***</h3>

			<ul>
				<li><Link to="/admsafe/newsletterMembers">Membres infolettre</Link></li>
				<li><Link to="/admsafe/testzone">Test Zone</Link></li>
				<li><Link to="/admsafe/DevScripting">Dev Scripts</Link></li>
			</ul>

			</div>
		);
	}

}

export default Admin_Dev;


